import "vuetify/styles";

import { createVuetify } from "vuetify";
import * as components from "vuetify/components";

import { aliases, fa } from "vuetify/iconsets/fa";
import icons from "@/config/vuetify/icons.json";
import darkTheme from "@/config/vuetify/dark_theme.json";

import { vuetifyConfig } from "@bisom/web_package";

export default createVuetify({
  components,

  defaults: {
    ...vuetifyConfig.default_component,
    VBtn: {
      color: "actionBtn",
      rounded: "lg",
      class: "text-uppercase",
    },
    VRow: {
      density: "compact",
      gap: "0",
    },
    VCol: {
      class: "pa-3",
    },
  },

  theme: {
    defaultTheme: "light",
    themes: {
      light: {
        colors: {
          ...vuetifyConfig.theme_light.colors,
          disabled: "#f5f5f5",
          successDark: "#004D40",
          mapSmurColor: "#68bb6b", // Couleur d'affichage sur la map d'un vecteur type SMUR
          report0: "#BDBDBD", // grey
          report1: "#81D4FA", // blue
          report2: "#4CAF50", // green
          report3: "#FFC107", // orange
          report4: "#F44336", // red
        },
      },
      dark: darkTheme,
    },
  },
  icons: {
    defaultSet: "fa",
    aliases: {
      ...aliases,
      ...icons,
      ...vuetifyConfig.icons,
    },
    sets: {
      fa,
    },
  },
});
